"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addSubQuestions = void 0;
const processDB_1 = require("./processDB");
function addSubQuestions(db, parentListId, idx, newQs) {
    const parentList = db.lists[parentListId];
    if (!parentList)
        return;
    const reversedQs = [...newQs].reverse();
    reversedQs.forEach(newQ => {
        (0, processDB_1.processQuestion)(db, newQ);
        parentList.childQIds.splice(idx, 0, newQ.qId);
    });
    (0, processDB_1.processListParent)(db, parentList);
}
exports.addSubQuestions = addSubQuestions;
exports.default = addSubQuestions;
